module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_plan_included_04-bf3aa129197217bd62d5d0f8e6e03b04.png";